/**
 * Who can confirm what, in the two-party handshake that releases an
 * assistant's money.
 *
 * A trip only starts, and the fee only becomes withdrawable, once BOTH the
 * traveller and the assistant confirm — first that the trip started, later
 * that it ended. These gates mirror what the server actually accepts
 * (confirmTripStart / confirmTripEnd in pulo_api): the start confirmation is
 * open from `accepted` onwards, because marking arrival is an optional signal
 * and not a precondition.
 *
 * Gating the traveller's button on `assistant_arrived` instead deadlocked the
 * whole flow — nothing in the product calls the arrival endpoint, so that
 * status never arrives, the traveller never saw a button, the trip never
 * started, and the assistant's fee stayed locked in her wallet indefinitely.
 */

export const START_CONFIRMABLE_STATUSES = ["accepted", "assistant_arrived"];

const canConfirmStartAt = (status) => START_CONFIRMABLE_STATUSES.includes(status);

/** The traveller's side of the handshake, for one booking. */
export const buildConfirmationFlags = (booking = {}) => {
  const atStart = canConfirmStartAt(booking?.status);
  const inTrip = booking?.status === "trip_started";
  const startConfirmed = Boolean(booking?.confirmations?.start?.user);
  const endConfirmed = Boolean(booking?.confirmations?.end?.user);

  return {
    canConfirmStart: atStart && !startConfirmed,
    canConfirmEnd: inTrip && !endConfirmed,
    // Confirmed from this side; the button gives way to a "waiting for your
    // assistant" note until the other party catches up.
    awaitingAssistantStart: atStart && startConfirmed,
    awaitingAssistantEnd: inTrip && endConfirmed,
  };
};
